import request from './index'
// import QS from 'qs'
/**
 * 内容详情
 */
export function contentDetail(query) {
  return request({
    url: `/zhongcheyun/content`,
    method: 'GET',
    params: query,
    headers: { scope: 1 }
  })
}
/**
 * 系统设置-详情
 * @param
 */
export function getSystemInfo(query) {
  return request({
    url: '/zhongcheyun/system/user',
    method: 'GET',
    params: query,
    headers: { scope: 1 }
  })
}
/**
 * 积分内容详情
 */
export function scoreDetail(query) {
  const number = query.number
  return request({
    url: `/zhongcheyun/point/sku/${number}`,
    method: 'GET',
    params: query,
    headers: { scope: 1 }
  })
}
/**
 * 首页统计空闲运力
 */
export function searchTransport(query) {
  return request({
    url: `/ums/stat`,
    method: 'GET',
    params: query,
    headers: { scope: 1 }
  })
}
/**
 * 首页统计计划单(路线)
 */
export function searchSource(query) {
  return request({
    url: `/plan/stat/route`,
    method: 'GET',
    params: query,
    headers: { scope: 1 }
  })
}
/**
 * 首页统计(订单详情)
 */
export function searchOrderDetail(query) {
  const orderNumber = query.orderNumber
  return request({
    url: `/loms/order/open/${orderNumber}`,
    method: 'GET',
    params: query,
    headers: { scope: 1 }
  })
}
/**
 * 首页车辆定位
 */
export function searchVehicleLocation(query) {
  return request({
    url: `/location/trail/vehicle/list/total`,
    method: 'GET',
    params: query,
    headers: { scope: 2 }
  })
}



// WEBPACK FOOTER //
// ./src/api/site.js